import styled, { css } from "styled-components";

export const Container = styled.div`
        padding: 20px 30px;
`;

export const Header = styled.div`
    padding: 0px 30px;
`;